import { render, staticRenderFns } from "./ContentSelectionSundayReactionDesktop.vue?vue&type=template&id=784ebed1&scoped=true&"
import script from "./ContentSelectionSundayReactionDesktop.vue?vue&type=script&lang=js&"
export * from "./ContentSelectionSundayReactionDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectionSundayReactionDesktop.vue?vue&type=style&index=0&id=784ebed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ebed1",
  null
  
)

export default component.exports